import React from "react";
import profile from "../../../../assets/images/profile1.jpg";

const Over = ({ users, player_status, colours = [] }) => {
  const winnerId = player_status.find((player) => {
    const values = Object.values(player.cards);
    const isWinner =
      values.every((value) => value >= 1) ||
      values.filter((value) => value >= 3).length >= 1;
    return isWinner;
  }).id;
  const winner = users.find((player) => player.player_id === winnerId);
  return (
    <>
      <div className="over-screen">
        <div className="ct-user">
          <img
            src={winner?.profile_image}
            className={`user ${colours[winner?.player_id - 1]}`}
          />
        </div>
        <h2>{winner?.display_name} Wins!</h2>
      </div>
    </>
  );
};

export default Over;
